/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Shalani Chethana
 * @Date 22/01/2025
 */

import { AppBar, Container, List, ListItem, ListItemButton, ListItemText, Toolbar, Tooltip } from '@mui/material'
import React from 'react'
import { Link } from 'react-router-dom'
import logo from '../../assets/images/logo.jpg'
import styles from "./navBar.module.css"
import DrawerMenu from './DrawerMenu'

import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const NavBar = () => {

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <nav position="static" className={styles.appBar}>
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <div style={{ display: 'flex', justifyContent: 'space-between', flexGrow: 1 }}>
            <div style={{}}>
              <Link to="/">
                <img className={styles.logo} src={logo} />
              </Link>
            </div>
            <div className={styles.toolbar}>
              <DrawerMenu />
            </div>
          </div>
          <div>
            <List className={styles.list}>
              <Link className={styles.listItem} to='/' >
                Home
              </Link>
              <Link className={styles.listItem} to='/aboutUs' >
                About Us
              </Link>
              <Link className={styles.listItem} to='/services' >
                Services
              </Link>
            
              <Link
                id="demo-positioned-button"
                aria-controls={open ? 'demo-positioned-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
                className={styles.listItem}
              >
                Products <KeyboardArrowDownIcon />
              </Link>

              <Menu
                id="demo-positioned-menu"
                aria-labelledby="demo-positioned-button"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'left',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'left',
                }}
                sx={{marginTop:5 }}
                PaperProps={{
                  sx: {
                    bgcolor: 'black', // Set background color to black
                  }
                }}
                className={styles.navMenuPaper}
              >
                {/* <MenuItem onClick={handleClose} disableRipple>
                <Link className={styles.listItemMenu} to='/products' >Products</Link>   
                </MenuItem> */}

                <MenuItem onClick={handleClose} disableRipple className={styles.menuItemCard}>
                <Link className={styles.listItemMenu} to='/ecom' >E-Commerce web</Link>
                </MenuItem>

                <MenuItem onClick={handleClose} disableRipple className={styles.menuItemCard} >
                <Link className={styles.listItemMenu} to='/hr' >HR Management System</Link>
                </MenuItem>

                <MenuItem onClick={handleClose} disableRipple className={styles.menuItemCard} >
                <Link className={styles.listItemMenu} to='/ims' >Issue Management System</Link>   
                </MenuItem>
                
                <MenuItem onClick={handleClose} disableRipple className={styles.menuItemCard} >
                <Link className={styles.listItemMenu} to='/crm' >CRM System</Link>
                </MenuItem>

                <MenuItem onClick={handleClose} disableRipple className={styles.menuItemCard} >
                <Link className={styles.listItemMenu} to='/payroll' >Payroll System</Link>
                </MenuItem>

                <MenuItem onClick={handleClose} disableRipple className={styles.menuItemCard} >
                <Link className={styles.listItemMenu} to='/eservice' >E Services</Link>   
                </MenuItem>
                
                <MenuItem onClick={handleClose} disableRipple className={styles.menuItemCard} >
                <Link className={styles.listItemMenu} to='/stock' >Stocks and Warehouse Monitoring</Link>
                </MenuItem>

                <MenuItem onClick={handleClose} disableRipple className={styles.menuItemCard} >
                <Link className={styles.listItemMenu} to='/pos' >Point Of Sale</Link>
                </MenuItem>

                <MenuItem onClick={handleClose} disableRipple className={styles.menuItemCard} >
                <Link className={styles.listItemMenu} to='/ecomlite' >E-Commerce lite web</Link>
                </MenuItem>
              </Menu>


              <Link className={styles.listItem} to='/contact' >
                Contact Us
              </Link>
              {/* <Link className={styles.listItem} href="tel:+94703259026" >
                Call Us : +94 703259026
              </Link>
              <Link className={styles.listItem} href="tel:+971586355200" >
                 / +971 586355200
              </Link> */}
            </List>
          </div>
        </Toolbar>
      </Container>
    </nav>
  )
}

export default NavBar